import { ComingSoon, Stack, Text, useT, useWorkspace } from "@bundle/ui";
import { Workspace } from "@bundle/core";
import { useEffect, useState } from "react";
import { ChannelScreen } from "./ChannelScreen.tsx";

/** /{ws}/dm/{user}: the DM channel with that person (created on first open). */
export function DmScreen({ userId }: { userId: string }) {
  const t = useT();
  const ws = useWorkspace();
  const cache = ws.state.cache;
  const existing = cache === undefined ? undefined : Workspace.dmChannelWith(cache, userId);
  const [failed, setFailed] = useState(false);
  const vm = ws.vm;
  const known = existing !== undefined;
  const hasCache = cache !== undefined;

  useEffect(() => {
    if (known || !hasCache) return;
    let cancelled = false;
    void vm.ensureDm(userId).then((id) => {
      if (!cancelled && id === undefined) setFailed(true);
    });
    return () => {
      cancelled = true;
    };
  }, [vm, userId, known, hasCache]);

  if (existing !== undefined) return <ChannelScreen channelId={existing.id} />;
  if (failed) return <ComingSoon icon="offline" title={t("offline.bannerNoCache")} body={t("common.error")} />;
  return (
    <Stack grow align="center" justify="center">
      <Text color="text.tertiary">{t("common.loading")}</Text>
    </Stack>
  );
}
